import { InputHTMLAttributes, forwardRef } from 'react'

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: React.ReactNode
  error?: string
  className?: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, disabled, className = '', ...props }, ref) => {
    return (
      <div className={`relative ${className}`}>
        <label className="flex text-zinc-700 cursor-pointer">
          <input
            type="checkbox"
            ref={ref}
            disabled={disabled}
            className="sr-only peer absolute top-[0.625rem] left-[0.625rem]"
            {...props}
          />
          <div className="relative min-w-5 h-5 mr-3 rounded-sm border border-gray-300 peer-checked:border-blue-600 peer-checked:bg-blue-600 transition-colors duration-200">
            <svg
              className="absolute inset-0 w-full h-full text-white stroke-[1.5] transition-opacity duration-200"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
            >
              <path
                d="M4.5 8L7 10.5L12.5 5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="text-xs">
            {label}
          </div>
        </label>
        {error && (
          <span className="text-sm text-red-500 mt-1">
            {error}
          </span>
        )}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'

export default Checkbox